/* eslint-disable @typescript-eslint/no-unused-vars */
import { Inject, Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { isPlatformBrowser } from '@angular/common';
import { ReferralNoticeService } from '../../services/referral-notice.service';
import { PENDING_REFERRAL_CODE_KEY } from '../constants/referral.const';

@Injectable({ providedIn: 'root' })
export class MainGuardService {
  private isBrowser: boolean;
  private referralNotice = inject(ReferralNoticeService);

  constructor(
    private router: Router,
    private authService: AuthService,
    @Inject(PLATFORM_ID) platformId: object,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  private readReferralCode(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): string | null {
    let code = next.queryParamMap.get('referralCode');

    if (!code && next.root?.queryParamMap) {
      code = next.root.queryParamMap.get('referralCode');
    }

    if (!code && state?.url) {
      try {
        const parsed = this.router.parseUrl(state.url);
        code = parsed.queryParamMap.get('referralCode');
      } catch {
        // ignore
      }
    }

    return code;
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this.isBrowser) {
      return true;
    }

    const token = this.authService.isAuthenticated();
    const referralCode = this.readReferralCode(next, state);

    if (referralCode) {
      if (token) {
        this.clearPendingReferralCode();
        this.referralNotice.queueError('ReferralAlreadyLoggedIn');
        return this.router.parseUrl('/services');
      }

      this.persistReferralCode(referralCode);
      // Allow get-started / auth routes for guest users redeeming a referral.
      return true;
    }

    if (token) {
      return this.router.parseUrl('/services');
    }
    return true;
  }

  private persistReferralCode(code: string): void {
    try {
      sessionStorage.setItem(PENDING_REFERRAL_CODE_KEY, code);
    } catch {
      // ignore storage errors
    }
  }

  private clearPendingReferralCode(): void {
    try {
      sessionStorage.removeItem(PENDING_REFERRAL_CODE_KEY);
    } catch {
      // ignore storage errors
    }
  }
}

export const MainGuard = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(MainGuardService).canActivate(next, state);
};
